import { zodResolver } from '@hookform/resolvers/zod';
import { VehicleCategory } from '@interfaces/models';
import { Validators } from '@helpers/constant';
import { useTranslation } from 'react-i18next';
import { useForm } from 'react-hook-form';
import { TFunction } from 'i18next';
import { z } from 'zod';

const editVehiclesFormSchema = (t: TFunction) =>
  z.object({
    registrationNumber: z
      .string()
      .min(4, t('FORMS.MIN_CHARACTERS', { limit: 4 }))
      .max(10, t('FORMS.MAX_CHARACTERS', { limit: 10 }))
      .regex(Validators.REGISTRATION_NUMBER, t('FORMS.INVALID_REGISTRATION_NUMBER')),
    registrationCountry: z.string().min(1, t('FORMS.REQUIRED')),
    vehicleCategory: z.nativeEnum(VehicleCategory, {
      message: t('FORMS.REQUIRED'),
    }),
    name: z
      .string()
      .min(2, t('FORMS.MIN_CHARACTERS', { limit: 2 }))
      .max(20, t('FORMS.MAX_CHARACTERS', { limit: 20 }))
      .optional()
      .or(z.literal('')),
    labels: z.array(z.string()).optional(),
  });

const defaultEditVehiclesValues = {
  vehicleCategory: '' as VehicleCategory,
  registrationCountry: 'PL',
  registrationNumber: '',
  labels: [],
  name: '',
};

export type EditVehiclesForm = z.infer<ReturnType<typeof editVehiclesFormSchema>>;

export const useEditVehiclesDrawerForm = () => {
  const { t } = useTranslation();

  const form = useForm({
    resolver: zodResolver(editVehiclesFormSchema(t)),
    defaultValues: defaultEditVehiclesValues,
    mode: 'onBlur',
  });

  return { form };
};
